import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormControl from "@mui/material/FormControl";

const ORDER_TYPES = [
  { value: "dine_in", label: "Dine In" },
  { value: "table_order", label: "Table Order" },
  { value: "takeaway", label: "Takeaway" },
  { value: "online_delivery", label: "Online Delivery" },
  { value: "table_booking", label: "Table Booking" },
];

const OrderTypeSelector = ({ 
  selectedTypes = [], 
  onChange, 
  label = "Exclude from Order Types",
  disabled = false 
}) => {
  const handleToggle = (orderType) => {
    if (disabled) return;
    
    const currentIndex = selectedTypes.indexOf(orderType);
    const newSelectedTypes = [...selectedTypes];

    if (currentIndex === -1) {
      newSelectedTypes.push(orderType);
    } else {
      newSelectedTypes.splice(currentIndex, 1);
    }

    onChange(newSelectedTypes);
  };

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.label}>{label}</Typography>
      <Typography sx={styles.helperText}>
        Select order types where this category should NOT be visible
      </Typography>
      <FormControl component="fieldset" sx={styles.formControl}>
        <FormGroup>
          {ORDER_TYPES.map((orderType) => (
            <FormControlLabel
              key={orderType.value}
              control={
                <Checkbox
                  checked={selectedTypes.includes(orderType.value)}
                  onChange={() => handleToggle(orderType.value)}
                  disabled={disabled}
                  sx={styles.checkbox}
                />
              }
              label={orderType.label}
              sx={styles.formControlLabel}
            />
          ))}
        </FormGroup>
      </FormControl>
      {selectedTypes.length > 0 && (
        <Box sx={styles.selectedInfo}>
          <Typography sx={styles.selectedInfoText}>
            This category will be hidden for: {selectedTypes.map(type => 
              ORDER_TYPES.find(ot => ot.value === type)?.label
            ).join(", ")}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default OrderTypeSelector;

const styles = {
  container: {
    width: "100%",
    mt: 2,
  },
  label: {
    color: "#AAA",
    fontSize: 12,
    fontFamily: "GilroyRegular",
    mb: 0.5,
  },
  helperText: {
    color: "#999",
    fontSize: 11,
    fontFamily: "GilroyRegular",
    mb: 1,
    fontStyle: "italic",
  },
  formControl: {
    width: "100%",
  },
  formControlLabel: {
    "& .MuiFormControlLabel-label": {
      fontSize: 13,
      fontFamily: "GilroyMedium",
      color: "#333",
    },
  },
  checkbox: {
    color: "#AAA",
    "&.Mui-checked": {
      color: "#000",
    },
  },
  selectedInfo: {
    mt: 1,
    p: 1.5,
    backgroundColor: "#FFF3CD",
    borderRadius: 1,
    border: "1px solid #FFE69C",
  },
  selectedInfoText: {
    fontSize: 12,
    fontFamily: "GilroyMedium",
    color: "#856404",
  },
};
